/**
 * Whether a reward line currently has an active payout override — i.e. a staged Set, or a
 * persisted override that isn't being cleared this session. A staged Clear wins over the
 * persisted state (the user is removing it).
 *
 * Used to reflect an active reward override in the UI (e.g. the pay-figure marker) and to
 * disable a reward's criteria controls once its payout is overridden directly.
 */
const hasActiveRewardOverride = ({
  rewardName,
  persistedRewardOverrides,
  stagedRewardOverrides,
}: {
  rewardName: string;
  persistedRewardOverrides:
    | BonusTypes.Overrides.PersistedRewardOverride[]
    | undefined;
  stagedRewardOverrides:
    | BonusTypes.Overrides.UserInputRewardOverride[]
    | undefined;
}): boolean => {
  const staged = stagedRewardOverrides?.find(
    (o) => o.rewardName === rewardName,
  );
  if (staged) {
    return staged.action === 'Set';
  }
  return !!persistedRewardOverrides?.some((o) => o.rewardName === rewardName);
};

export default hasActiveRewardOverride;
